import http from 'conversations-http/clients/http';
import { useEffect, useState } from 'react';

// https://tools.hubteam.com/api-catalog/services/AutomationPlatformService/v1/spec/internal#operations-Flows-get-%2Fautomationplatform%2Fv1%2Fflows%2F%7BflowId%7D
import { jsx as _jsx } from "react/jsx-runtime";
function fetchWorkflow({
  flowId
}) {
  return http.get(`/automationplatform/v1/flows/${flowId}`);
}
function useWorkflowName({
  flowId
}) {
  const [workflowData, setWorfklowData] = useState();
  useEffect(() => {
    fetchWorkflow({
      flowId
    }).then(response => setWorfklowData(response)).catch(() => {
      // doesn't matter, just keep the workflow data undefined
    });
  }, [flowId]);
  const workflowName = workflowData && workflowData.name;
  return {
    workflowName
  };
}
export function withWorkflowName(Component) {
  function ComponentWithWorkflowName(props) {
    const flowId = props.message && props.message.flowId;
    const {
      workflowName
    } = useWorkflowName({
      flowId
    });
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      workflowName: workflowName
    }));
  }
  ComponentWithWorkflowName.displayName = `withWorkflowName(${Component.displayName})`;
  return ComponentWithWorkflowName;
}